import {
  ExtendButtonBase,
  ListItem,
  ListItemButton,
  ListItemButtonTypeMap,
  ListItemIcon,
  ListItemText,
  styled,
  Typography,
} from '@mui/material';
import { CaretRight } from '@phosphor-icons/react';

import { multilineEllipsisOverflow } from 'theSource/utils';

export const ListItemStyled = styled(ListItem)(({ theme }) => ({
  padding: 0,
  borderBottom: `0.1rem solid ${theme.palette.grey[200]}`,
})) as typeof ListItem;

export const ListItemButtonStyled = styled(ListItemButton)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(4, 0, 4, 2),
})) as ExtendButtonBase<ListItemButtonTypeMap<{}>>;

export const ListItemTextStyled = styled(ListItemText)({
  margin: 0,
  maxWidth: '85%',
});

export const TitleStyled = styled(Typography)({
  wordWrap: 'break-word',
}) as typeof Typography;

export const MessageStyled = styled(Typography)(({ theme }) => ({
  maxHeight: theme.spacing(8),
  color: theme.palette.grey[500],
  ...multilineEllipsisOverflow(2),
})) as typeof Typography;

export const DaysMessageStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
})) as typeof Typography;

export const ListItemIconStyled = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  minWidth: 0,
  alignItems: 'center',
}));

export const CaretRightStyled = styled(CaretRight)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '2rem',
}));
